import React, { useState } from 'react'
import { ClipLoader } from 'react-spinners';

export default function PendingInvitations({invitations}){
  return(
    <div className="mt-3 p-1">
      <div className="pb-2 pt-2 font-weight-bold unselectable">Pending Invitations</div>
      <div className="pt-2">
        {
          invitations.map(invitation=>{
            return <InvitationListing key={invitation.id} invitation={invitation}/>
          })
        }
      </div>
      <div className="pt-3"/>
    </div>
  )
}

function InvitationListing({ invitation }){
  const [ submittingAccept, setSubmittingAccept ] = useState(false)
  const [ submittingDecline, setSubmittingDecline ] = useState(false)
  function accept(){
    if(!submittingDecline){
      setSubmittingAccept(true)
      $.ajax({
        url: `invitations/${invitation.id}/accept`,
        method: 'PATCH'
      })
    }
  }

  function decline(){
    if(!submittingAccept){
      setSubmittingDecline(true)
      $.ajax({
        url: `invitations/${invitation.id}/decline`,
        method: 'PATCH'
      })
    }
  }
  return(
    <div className="d-flex align-items-center">
      { submittingAccept ?  
          <ClipLoader
            sizeUnit={"px"}
            size={12}
            color={"#4dbd74"}
            loading={true}/> : 
          <div onClick={ () => accept() }>
            <div className="fas fa-check-circle text-success"/>
          </div>
      }
      { submittingDecline ?  
        <div className="ml-2 d-inline-block">
          <ClipLoader
              className="ml-2"
              sizeUnit={"px"}
              size={12}
              color={"#f86c6b"}
              loading={true}/> 
        </div> : 
        <div onClick={()=> decline()}>
          <div className="fas fa-times-circle text-danger ml-2"/>
        </div>
      }
      <a className="pl-2" href={`events/${invitation.event.id}`}>{invitation.event.title}</a>
    </div>
  )
}